import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography } from '../utils'

export const VerticalMenuDesignSettings = {
  // Vertical Menu
  'vertical-menu-design-title-margin': {
    phone: getDefaultMargin([20, 0]),
    'phone-landscape': getDefaultMargin([20, 0]),
    tablet: getDefaultMargin([20, 0]),
    'tablet-landscape': getDefaultMargin([20, 0]),
    desktop: getDefaultMargin([20, 0]),
    tv: getDefaultMargin([20, 0]),
    overflowSetting: getDefaultMarginOverlay,
  },
  'vertical-menu-design-items-margin': {
    phone: getDefaultMargin([10, 0]),
    'phone-landscape': getDefaultMargin([10, 0]),
    tablet: getDefaultMargin([10, 0]),
    'tablet-landscape': getDefaultMargin([10, 0]),
    desktop: getDefaultMargin([10, 0]),
    tv: getDefaultMargin([10, 0]),
  },
  'vertical-menu-design-comp-margin': {
    phone: getDefaultMargin([0, 16]),
    'phone-landscape': getDefaultMargin([0, 16]),
    tablet: getDefaultMargin([0, 16]),
    'tablet-landscape': getDefaultMargin([0, 16]),
    desktop: getDefaultMargin([0, 16]),
    tv: getDefaultMargin([0, 16]),
  },
  'vertical-menu-design-typography': {
    'vertical-menu-design-title-typography': {
      phone: getDefaultTypography('Title Medium'),
      'phone-landscape': getDefaultTypography('Title Medium'),
      tablet: getDefaultTypography('Title Medium'),
      'tablet-landscape': getDefaultTypography('Title Medium'),
      desktop: getDefaultTypography('Title Medium'),
      tv: getDefaultTypography('Title Medium'),
    },
    'vertical-menu-design-items-typography': {
      phone: getDefaultTypography('Body Medium'),
      'phone-landscape': getDefaultTypography('Body Medium'),
      tablet: getDefaultTypography('Body Medium'),
      'tablet-landscape': getDefaultTypography('Body Medium'),
      desktop: getDefaultTypography('Body Medium'),
      tv: getDefaultTypography('Body Medium'),
    },
  },
  'vertical-menu-design-title-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'vertical-menu-design-title-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'vertical-menu-design-title-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'vertical-menu-design-title-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'vertical-menu-design-title-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'vertical-menu-design-items-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'vertical-menu-design-items-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'vertical-menu-design-items-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'vertical-menu-design-items-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'vertical-menu-design-items-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'vertical-menu-data-max-visible-items': {
    phone: 0,
    'phone-landscape': 50,
    tablet: 0,
    'tablet-landscape': 50,
    desktop: 50,
    tv: 50,
  },
  'vertical-menu-design-overflow-menu-background-color': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'vertical-menu-design-overflow-menu-button-size': {
    phone: 'md',
    'phone-landscape': 'md',
    tablet: 'md',
    'tablet-landscape': 'md',
    desktop: 'md',
    tv: 'md',
  },
  'vertical-menu-design-overflow-menu-button-shape': {
    phone: 'medium',
    'phone-landscape': 'medium',
    tablet: 'medium',
    'tablet-landscape': 'medium',
    desktop: 'medium',
    tv: 'medium',
  },
  'vertical-menu-design-overflow-menu-dropdown-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },
}
